<template lang="pug">
.modal-sesame-go(v-if="visible", @touchmove.prevent)
  .modal-container
    .info-title 确定要退出芝麻GO吗？
    .subtitle 若未完成任务，已使用
      .warning 优惠结算后扣除
    .chart
    .footer
      .close(@click='close') 再想想
      .confirm(@click="confirm") 确定退出

</template>

<script>
import { signOutZhiMaExit } from '@/api/zhima-go.js';
import { getTokenAndKey } from '@/utils';
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      taskGroupCode: '',
      param: {}, // close时发送
    };
  },
  methods: {
    open(param) {
      this.visible = true;
      this.taskGroupCode = param.taskGroupCode;
      UBT.moduleExpose({
        pageId: 'platform_zhima',
        categoryId: 'platform',
        moduleId: 'zhima_pop',
        contentId: 'zhima_pop',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    close() {
      UBT.clickButton({
        pageId: 'platform_zhima',
        buttonName: 'zhima_think',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.visible = false;
      this.$emit('close', this.param);
    },
    async confirm() {
      UBT.clickButton({
        pageId: 'platform_zhima',
        buttonName: 'zhima_exit',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndKey();
      signOutZhiMaExit({
        token,
        taskGroupCode: this.taskGroupCode,
      }).then(() => {
        Toast.show('已退出芝麻GO任务');
        this.$emit('confirm', this.param);
      }).catch((e) => {
        Toast.show(e && e.message ? e.message : '退出芝麻GO任务失败');
      });
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-sesame-go {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-container {
  margin: 2.3rem auto;
  width: 3.2rem;
  height: 1.77rem;
  background: #fff;
  border-radius: 0.12rem;
  position: relative;
  padding-top: 0.24rem;

  .info-title {
    margin: 0 auto;
    height: 0.25rem;
    font-size: 0.18rem;
    font-weight: 500;
    color: #242729;
    line-height: 0.25rem;
    text-align: center;
  }

  .subtitle {
    margin-top: 0.16rem;
    margin-bottom: 0.24rem;
    height: 0.2rem;
    text-align: center;
    font-size: 0.14rem;
    font-weight: 400;
    color: #5a6066;
    line-height: 0.2rem;

    .warning {
      display: inline-block;
      color: #e85d55;
    }
  }

  .footer {
    margin-top: 0.2rem;
    margin-left: 0.16rem;
    display: flex;

    .close {
      width: 1.4rem;
      height: 0.48rem;
      background: #f0f3f5;
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.48rem;
      text-align: center;
      margin-right: 0.08rem;
    }

    .confirm {
      width: 1.4rem;
      height: 0.48rem;
      background: #08f;
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.48rem;
      text-align: center;
    }
  }
}
</style>
